import { createSlice } from '@reduxjs/toolkit';

export type Attachment = {
  id: number;
  content: string;
  file: File | null;
};

export type Document = {
  id: number;
  name: string;
  belonging: string;
  tags: string[];
  attachments: Attachment[];
};

type InitialState = {
  documents: Document[] | null;
};

const initialState: InitialState = {
  documents: null,
};

const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    setDocumentsData: (state, action: { payload: Document[] }) => {
      state.documents = action.payload?.map(doc => ({
        ...doc,
        attachments: (doc.attachments || []).map((attachment: Attachment) => ({
          ...attachment,
          file: attachment.content
            ? new File([attachment.content], attachment.content?.split('/').pop() || 'unknown', {
                type: 'application/octet-stream',
              })
            : new File([], 'empty', { type: 'application/octet-stream' }),
        })),
      }));
    },
  },
});

export const { setDocumentsData } = documentsSlice.actions;
export default documentsSlice.reducer;
